import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { emptyFragment } from '../../../../../EmptyFragment';
import ParticipantStore from '../../../../../ParticipantStore';
import { L, NotTranslated, T } from '../../../../../Translations';
import BigCheckmarkCircleIcon from '../../../../Cutesies/BigCheckmarkCircleIcon';
import Button from '../../../../Form/Button';
import Modal from '../../../../Modal';
import LicenseAllocationsStore from './Store';
import { Submitted } from './Types';

interface Props {
  state: Submitted;
  licenseAllocationsStore: LicenseAllocationsStore;
  participantStore: ParticipantStore;
}

const handleDone = (
  licenseAllocationsStore: LicenseAllocationsStore,
  participantStore: ParticipantStore,
) => {
  licenseAllocationsStore.waiting();
  participantStore.participantsStore.loading(1);
};

function ModalSubmitted({ state, licenseAllocationsStore, participantStore }: Props) {
  return (
    <Modal close={licenseAllocationsStore.waiting} title="">
      <div className="flex flex-col w-full items-center">
        <BigCheckmarkCircleIcon width="160" height="160" />
        <div className="text-2xl font-bold">
          <T kind="License Allocation Successful" />
        </div>
        <div className="py-4">
          {participantStore.resource.payload.fullName
            .map((name) => (
              <T kind="You allocated the following license(s) to {{name}}:" name={name} />
            ))
            .getOrElse(() => (
              <T kind="You allocated the following license(s):" />
            ))}
        </div>
        {state.resource.payload.allocatedLicenses.map(({ payload: license }) => (
          <React.Fragment key={license.id}>
            <div className="font-bold">
              <NotTranslated text={license.name} />
            </div>
            <div className="divide-x divide-solid divide-black">
              <span className="px-1">
                <T
                  kind="Expires <date/>"
                  date={<L localizeable={license.expiresOn} format={'short-month-day-year'} />}
                />
              </span>
              {license.activationsRemaining
                .map((count) => (
                  <span className="px-1">
                    <T kind="Activations Remaining: {{count}}" count={count} />
                  </span>
                ))
                .getOrElse(emptyFragment)}
            </div>
          </React.Fragment>
        ))}
        <Button
          type="button"
          value="Done"
          onClick={() => handleDone(licenseAllocationsStore, participantStore)}
          className={clsx(
            'my-12 cursor-pointer w-72 rounded-md font-semibold',
            'bg-teal-600 px-4 py-2 text-base text-white',
          )}
        />
      </div>
    </Modal>
  );
}

export default observer(ModalSubmitted);
